export default __webpack_public_path__ + "static/white-logo-840f617593bd6f5344bff4063ccca413.jpeg";